<template>
	<div>
		<v-expansion-panels v-model="panel" flat accordion>
			<ExpansionPanel :title="'Basics'">
				<div>URL</div>
				<CombinedInputFieldDataMenu class="mb-6" :textAreaMode="true" :value.sync="calendlyLink" :valuesTypes="dataInputMenuValueTypes" />
			</ExpansionPanel>
			<ExpansionPanel :title="'Advanced'">
				<SettingSwitch :title="'Show Event Details'" :switchValue.sync="isAddDescription" />
				<SettingSwitch :title="'Show Cookie Banner'" :switchValue.sync="isAddCookies" />
				<div class="pt-2">Confirmation Handling:</div>
				<AppSelect
					:items="CALENDLY_SETTINGS_CONFIRMATION_OPTIONS"
					outlined
					dense
					placeholder="Automatically proceed to next step with animation"
					item-text="title"
					item-value="value"
					v-model="confirmationHandlingOption"
				></AppSelect>
			</ExpansionPanel>
		</v-expansion-panels>
		<div class="info-box">To use data from scheduled events in later steps, add the Calendly action "Get mini-app output".</div>
	</div>
</template>

<script>
import ItemOnlyAllowedValueTypesMixin from './ValueTypesMixins/ItemOnlyAllowedValueTypesMixin';
import ExpansionPanel from './WidgetSettings/ExpansionPanel';
import SettingSwitch from './WidgetSettings/SettingSwitch';
import { CALENDLY_SETTINGS_CONFIRMATION_OPTIONS } from '../calendly-mini-app.const';
import FieldSettingsMixin, { getComputedMetadataOption } from '@/components/BlockEditorWidget/FieldSettings/FieldSettingsMixin';
import CombinedInputFieldDataMenu from '@/components/DataInput/CombinedInputFieldDataMenu';

export default {
	name: 'CalendlyFieldSettings',
	mixins: [FieldSettingsMixin, ItemOnlyAllowedValueTypesMixin],
	components: {
		ExpansionPanel,
		SettingSwitch,
		CombinedInputFieldDataMenu,
	},
	computed: {
		metadataOptions() {
			return this.localField.metadata.options;
		},
		confirmationHandlingOption: getComputedMetadataOption('confirmation_handling_option', 'value'),
		calendlyLink: getComputedMetadataOption('calendly_link', 'value'),
		isAddDescription: getComputedMetadataOption('is_add_description', 'enabled'),
		isAddCookies: getComputedMetadataOption('is_add_cookies', 'enabled'),
	},
	data() {
		return { CALENDLY_SETTINGS_CONFIRMATION_OPTIONS };
	},
	methods: {},
};
</script>

<style scoped>
div > .info-box {
	font-size: 12px;
	color: var(--Colors-Neutral-Text-colorTextSecondary, #646e87);
	background-color: #f9fafc;
	padding: 10px;
	border-radius: 5px;
	margin-top: 20px;
}

div > .info-box > a {
	color: #5d8ff6;
	text-decoration: underline;
}
</style>
